var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyStateTeam(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 72,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62 0l14.765958 23.4.047232.074916-36.786726 47.822832C39.686336 71.740728 39.15899 72 38.6 72l-8.1-24.3L38.6 72c-.55899 0-1.086336-.259272-1.426482-.702234L.386792 23.474934.434042 23.4 15.2 0h23.4L22.4 23.4l8.1 24.3-8.1-24.3h32.4L38.6 0H62zm-7.2 23.4H22.4L38.6 0l16.2 23.4z",
    fill: "#EEECF0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2DEE5",
    d: "M76.765958 23.4L62 0l-7.2 23.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8F7F9",
    d: "M15.2 0L.434042 23.4H22.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2DEE5",
    d: "M22.4 23.4L38.6 72l16.2-48.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8F7F9",
    d: "M54.8 23.4L38.6 0 22.4 23.4z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateTeam);
export default __webpack_public_path__ + "static/media/empty-state-team.b310eb43a05f48f18d8259fc26b7cdff.svg";
export { ForwardRef as ReactComponent };